import MainPage from "./counterfeit-report.container";


export default MainPage;
